<template>
    <BusinessOmniplayEventsSimpleCoreVue :dateDimension="dateDimension" :title="title">
    </BusinessOmniplayEventsSimpleCoreVue>
</template>


<script>


import BusinessOmniplayEventsSimpleCoreVue, { BusinessOmniplayEventsSimpleCore } from '@/views/events/core/BusinessOmniplayEventsSimpleCore.vue';
import { BusinessOmniplayEventsOrderSimple } from '@/router/routeNames';
import dimensionEnum from '@/model/dimensionEnum';



export default {
    name: BusinessOmniplayEventsOrderSimple,
    data() {
        return {
            dateDimension: dimensionEnum.OMNIPLAYEVENT_ORDERBUSINESSDATE,
            title: this.$t('title.business_events_order_simple')
        };
    },
    mounted() {
    },
    computed: {},
    methods: {},
    components: { BusinessOmniplayEventsSimpleCoreVue }
}

</script>